import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ModelTier = "base" | "pro";

export interface ModelTierState {
  bySession: Record<string, ModelTier>;
}

const initialState: ModelTierState = {
  bySession: {},
};

export const modelTierSlice = createSlice({
  name: "modelTier",
  initialState,
  reducers: {
    setModelTier: (state, action: PayloadAction<{ sessionId: string; tier: ModelTier }>) => {
      state.bySession[action.payload.sessionId] = action.payload.tier;
    },
  },
});

export const { setModelTier } = modelTierSlice.actions;

export const selectModelTier = (
  state: { modelTier: ModelTierState },
  sessionId: string | undefined,
): ModelTier => (sessionId && state.modelTier.bySession[sessionId]) || "base";

export default modelTierSlice.reducer;
